import React from "react";
import { CTA_MICRO_DISCLOSURE } from "../shared/ctaContent.js";
import HeroBenefitList from "../shared/HeroBenefitList.jsx";
import QuietVideoPlayer from "../shared/QuietVideoPlayer.jsx";

const QuietHero = ({ onOpenModal }) => (
  <section className="cursor-section" data-testid="quiet-hero">
    <div className="cursor-container">
      <div className="cursor-hero-message" data-testid="quiet-headline">
        <h1 className="cursor-hero-h1">
          Watch this 60-second video to see how FractoLabs:
        </h1>
        <HeroBenefitList />
      </div>

      <QuietVideoPlayer />

      <div className="cursor-hero-cta-block">
        <div className="cursor-hero-cta-shell">
          <button
            type="button"
            className="quiet-cta quiet-cta-primary"
            onClick={onOpenModal}
            data-testid="quiet-hero-cta"
          >
            <span>Plug FractoLabs in (Free)</span>
            <span className="quiet-cta-arrow" aria-hidden="true">
              →
            </span>
          </button>
          <div className="cursor-cta-caption-block" data-testid="quiet-hero-cta-disclosure">
            <p className="cursor-cta-caption">{CTA_MICRO_DISCLOSURE.line1}</p>
            <p className="cursor-cta-caption cursor-cta-caption-secondary">
              {CTA_MICRO_DISCLOSURE.line2}
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default QuietHero;
